import type { Legal, NavLinkColumn } from './types'

export const legal_us: Legal[] = [
  {
    key: 'privacy_notice',
    name: 'Privacy Notice',
    href: '/us/privacy',
  },
  {
    key: 'Do Not Sell My Personal Information',
    name: 'Do Not Sell My Personal Information',
    href: '/us/personal',
  },
  {
    key: 'legal',
    name: 'Legal',
    href: '/us/legal',
  },
  {
    key: 'status',
    name: 'Status',
    href: 'https://status.crypto.com',
  },
]

export const desktop_us: NavLinkColumn[] = [
  [
    {
      tTitle: 'products.app',
      tBadgeTitle: null,
      href: null,
      items: [
        {
          tTitle: 'products.buyAndSell',
          href: '/us/app',
        },
        {
          tTitle: 'products.earn',
          href: '/us/earn',
        },
        {
          tTitle: 'products.pay',
          href: '/us/pay',
        },
      ],
    },
    {
      tTitle: 'products.cards',
      tBadgeTitle: null,
      href: null,
      items: [
        {
          tTitle: 'products.metalCards',
          href: '/us/cards',
        },
      ],
    },
  ],
  [
    {
      tTitle: 'products.commerce',
      tBadgeTitle: null,
      href: null,
      items: [
        {
          tTitle: 'products.payMerchant',
          href: '/us/pay-merchant',
        },
      ],
    },
  ],
  [
    {
      tTitle: 'products.defi',
      tBadgeTitle: null,
      href: null,
      items: [
        {
          tTitle: 'products.wallet',
          href: '/us/defi-wallet',
        },
        {
          tTitle: 'products.swap',
          href: 'https://crypto.com/defi/swap',
        },
        {
          tTitle: 'products.defiEarn',
          href: '/us/defi-wallet#earn',
        },
        {
          tTitle: 'products.dashboard',
          href: 'https://crypto.com/defi/dashboard/gas-fees',
        },
      ],
    },
  ],
  [
    {
      tTitle: 'products.resources',
      tBadgeTitle: null,
      href: null,
      items: [
        {
          tTitle: 'products.prices',
          href: 'https://crypto.com/price',
        },
        {
          tTitle: 'products.siteWidgets',
          href: 'https://crypto.com/price/widget',
        },
        {
          tTitle: 'products.tax',
          href: 'https://tax.crypto.com',
        },
        {
          tTitle: 'company.support',
          href: 'https://help.crypto.com/en',
        },
        {
          tTitle: 'products.por',
          href: '/us/proof-of-reserves',
        },
      ],
    },
  ],
  [
    {
      tTitle: 'navbar.learn',
      tBadgeTitle: null,
      href: null,
      items: [
        {
          tTitle: 'learn.trending',
          href: '/trending',
        },
        {
          tTitle: 'learn.productNews',
          href: '/product-news',
        },
        {
          tTitle: 'learn.events',
          href: '/events',
        },
        {
          tTitle: 'learn.university',
          href: '/university',
        },
        {
          tTitle: 'learn.research',
          href: '/research',
        },
        {
          tTitle: 'learn.marketUpdates',
          href: '/market-updates',
        },
        {
          tTitle: 'learn.nftStories',
          href: '/nft-stories',
        },
      ],
    },
  ],
  [
    {
      tTitle: 'navbar.company',
      tBadgeTitle: null,
      href: null,
      items: [
        {
          tTitle: 'company.about',
          href: '/us/about',
        },
        {
          tTitle: 'company.careers',
          href: '/us/careers',
        },
        {
          tTitle: 'company.news',
          href: 'https://crypto.com/company-news',
        },
        {
          tTitle: 'company.security',
          href: '/us/security',
        },
        {
          tTitle: 'company.contact',
          href: '/us/about#page-contact',
        },
        {
          tTitle: 'company.capital',
          href: '/us/capital',
        },
        {
          tTitle: 'company.climate',
          href: 'https://crypto.com/company-news/crypto-coms-climate-commitment-2',
        },
        {
          tTitle: 'company.affiliate',
          href: '/us/affiliate',
        },
        {
          tTitle: 'company.partners',
          href: '/us/partners',
        },
        {
          tTitle: 'navbar.nft',
          href: 'https://crypto.com/nft',
          tBadgeTitle: 'navbar.new',
        },
      ],
    },
  ],
]

export const mobile_us = desktop_us
  .flatMap((menu) => menu)
  .map(({ items, ...rest }) => ({
    items: items.filter(({ tTitle }) => tTitle !== 'navbar.nft'),
    ...rest,
  }))
  .concat([
    {
      tTitle: 'navbar.nft',
      tBadgeTitle: 'navbar.new',
      href: 'https://crypto.com/nft',
      items: [],
    },
  ])
